import createIcon from '../../createIcon';

/**
 * @component @name Face5
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,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)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Face5 = createIcon('Face5', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 10.88 4.23 9.82 4.65 8.85C4.74 8.94 4.86 9 5 9C5.28 9 5.5 8.78 5.5 8.5C5.5 8.25 5.31 8.05 5.07 8.01C5.22 7.75 5.39 7.5 5.56 7.26C5.53 7.34 5.5 7.41 5.5 7.5C5.5 7.78 5.72 8 6 8C6.28 8 6.5 7.78 6.5 7.5C6.5 7.22 6.28 7 6 7C5.87 7 5.75 7.05 5.66 7.13C6.18 6.45 6.81 5.85 7.52 5.37C7.51 5.41 7.5 5.45 7.5 5.5C7.5 5.78 7.72 6 8 6C8.28 6 8.5 5.78 8.5 5.5C8.5 5.26 8.33 5.07 8.1 5.02C8.26 4.93 8.42 4.85 8.59 4.77C8.68 4.91 8.83 5 9 5C9.28 5 9.5 4.78 9.5 4.5C9.5 4.47 9.49 4.44 9.48 4.41C9.87 4.28 10.27 4.18 10.69 4.11C10.58 4.21 10.5 4.34 10.5 4.5C10.5 4.78 10.72 5 11 5C11.28 5 11.5 4.78 11.5 4.5C11.5 4.29 11.37 4.12 11.2 4.04C11.46 4.01 11.73 4 12 4C12.27 4 12.54 4.01 12.8 4.04C12.62 4.12 12.5 4.29 12.5 4.5C12.5 4.78 12.72 5 13 5C13.28 5 13.5 4.78 13.5 4.5C13.5 4.34 13.42 4.21 13.31 4.12C13.72 4.19 14.13 4.29 14.52 4.42C14.51 4.44 14.5 4.47 14.5 4.5C14.5 4.78 14.72 5 15 5C15.17 5 15.32 4.91 15.41 4.77C15.58 4.85 15.74 4.93 15.9 5.02C15.67 5.07 15.5 5.26 15.5 5.5C15.5 5.78 15.72 6 16 6C16.28 6 16.5 5.78 16.5 5.5C16.5 5.45 16.49 5.41 16.47 5.37C17.18 5.85 17.81 6.45 18.33 7.13C18.25 7.05 18.13 7 18 7C17.72 7 17.5 7.22 17.5 7.5C17.5 7.78 17.72 8 18 8C18.28 8 18.5 7.78 18.5 7.5C18.5 7.41 18.47 7.34 18.43 7.27C18.61 7.51 18.77 7.76 18.92 8.02C18.69 8.05 18.5 8.25 18.5 8.5C18.5 8.78 18.72 9 19 9C19.14 9 19.26 8.94 19.35 8.85C19.77 9.82 20 10.88 20 12C20 16.41 16.41 20 12 20Z',
      key: '2kqp3j',
    },
  ],
  [
    'path',
    {
      d: 'M9 14.25C9.69036 14.25 10.25 13.6904 10.25 13C10.25 12.3096 9.69036 11.75 9 11.75C8.30964 11.75 7.75 12.3096 7.75 13C7.75 13.6904 8.30964 14.25 9 14.25Z',
      key: '1stqvt',
    },
  ],
  [
    'path',
    {
      d: 'M12 6C12.2761 6 12.5 5.77614 12.5 5.5C12.5 5.22386 12.2761 5 12 5C11.7239 5 11.5 5.22386 11.5 5.5C11.5 5.77614 11.7239 6 12 6Z',
      key: '1ylmmp',
    },
  ],
  [
    'path',
    {
      d: 'M14 6C14.2761 6 14.5 5.77614 14.5 5.5C14.5 5.22386 14.2761 5 14 5C13.7239 5 13.5 5.22386 13.5 5.5C13.5 5.77614 13.7239 6 14 6Z',
      key: '1qxswk',
    },
  ],
  [
    'path',
    {
      d: 'M10 6C10.2761 6 10.5 5.77614 10.5 5.5C10.5 5.22386 10.2761 5 10 5C9.72386 5 9.5 5.22386 9.5 5.5C9.5 5.77614 9.72386 6 10 6Z',
      key: 'hpjyqn',
    },
  ],
  [
    'path',
    {
      d: 'M17 7C17.2761 7 17.5 6.77614 17.5 6.5C17.5 6.22386 17.2761 6 17 6C16.7239 6 16.5 6.22386 16.5 6.5C16.5 6.77614 16.7239 7 17 7Z',
      key: '11v70b',
    },
  ],
  [
    'path',
    {
      d: 'M9 7C9.27614 7 9.5 6.77614 9.5 6.5C9.5 6.22386 9.27614 6 9 6C8.72386 6 8.5 6.22386 8.5 6.5C8.5 6.77614 8.72386 7 9 7Z',
      key: 'z0thx9',
    },
  ],
  [
    'path',
    {
      d: 'M7 7C7.27614 7 7.5 6.77614 7.5 6.5C7.5 6.22386 7.27614 6 7 6C6.72386 6 6.5 6.22386 6.5 6.5C6.5 6.77614 6.72386 7 7 7Z',
      key: '145uja',
    },
  ],
  [
    'path',
    {
      d: 'M11 7C11.2761 7 11.5 6.77614 11.5 6.5C11.5 6.22386 11.2761 6 11 6C10.7239 6 10.5 6.22386 10.5 6.5C10.5 6.77614 10.7239 7 11 7Z',
      key: '1pn5tk',
    },
  ],
  [
    'path',
    {
      d: 'M13 7C13.2761 7 13.5 6.77614 13.5 6.5C13.5 6.22386 13.2761 6 13 6C12.7239 6 12.5 6.22386 12.5 6.5C12.5 6.77614 12.7239 7 13 7Z',
      key: 'p7zbs6',
    },
  ],
  [
    'path',
    {
      d: 'M15 7C15.2761 7 15.5 6.77614 15.5 6.5C15.5 6.22386 15.2761 6 15 6C14.7239 6 14.5 6.22386 14.5 6.5C14.5 6.77614 14.7239 7 15 7Z',
      key: '399g4g',
    },
  ],
  [
    'path',
    {
      d: 'M12 8C12.2761 8 12.5 7.77614 12.5 7.5C12.5 7.22386 12.2761 7 12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8Z',
      key: '544z50',
    },
  ],
  [
    'path',
    {
      d: 'M14 8C14.2761 8 14.5 7.77614 14.5 7.5C14.5 7.22386 14.2761 7 14 7C13.7239 7 13.5 7.22386 13.5 7.5C13.5 7.77614 13.7239 8 14 8Z',
      key: 'ib7ucm',
    },
  ],
  [
    'path',
    {
      d: 'M16 8C16.2761 8 16.5 7.77614 16.5 7.5C16.5 7.22386 16.2761 7 16 7C15.7239 7 15.5 7.22386 15.5 7.5C15.5 7.77614 15.7239 8 16 8Z',
      key: '10taok',
    },
  ],
  [
    'path',
    {
      d: 'M10 8C10.2761 8 10.5 7.77614 10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5C9.5 7.77614 9.72386 8 10 8Z',
      key: 'o507j1',
    },
  ],
  [
    'path',
    {
      d: 'M8 8C8.27614 8 8.5 7.77614 8.5 7.5C8.5 7.22386 8.27614 7 8 7C7.72386 7 7.5 7.22386 7.5 7.5C7.5 7.77614 7.72386 8 8 8Z',
      key: '5cjtf7',
    },
  ],
  [
    'path',
    {
      d: 'M9 9C9.27614 9 9.5 8.77614 9.5 8.5C9.5 8.22386 9.27614 8 9 8C8.72386 8 8.5 8.22386 8.5 8.5C8.5 8.77614 8.72386 9 9 9Z',
      key: 'w2q5yr',
    },
  ],
  [
    'path',
    {
      d: 'M7 9C7.27614 9 7.5 8.77614 7.5 8.5C7.5 8.22386 7.27614 8 7 8C6.72386 8 6.5 8.22386 6.5 8.5C6.5 8.77614 6.72386 9 7 9Z',
      key: 'ckrkhp',
    },
  ],
  [
    'path',
    {
      d: 'M11 9C11.2761 9 11.5 8.77614 11.5 8.5C11.5 8.22386 11.2761 8 11 8C10.7239 8 10.5 8.22386 10.5 8.5C10.5 8.77614 10.7239 9 11 9Z',
      key: '9uks8a',
    },
  ],
  [
    'path',
    {
      d: 'M13 9C13.2761 9 13.5 8.77614 13.5 8.5C13.5 8.22386 13.2761 8 13 8C12.7239 8 12.5 8.22386 12.5 8.5C12.5 8.77614 12.7239 9 13 9Z',
      key: '1aou0d',
    },
  ],
  [
    'path',
    {
      d: 'M15 9C15.2761 9 15.5 8.77614 15.5 8.5C15.5 8.22386 15.2761 8 15 8C14.7239 8 14.5 8.22386 14.5 8.5C14.5 8.77614 14.7239 9 15 9Z',
      key: '1ma5qs',
    },
  ],
  [
    'path',
    {
      d: 'M17 9C17.2761 9 17.5 8.77614 17.5 8.5C17.5 8.22386 17.2761 8 17 8C16.7239 8 16.5 8.22386 16.5 8.5C16.5 8.77614 16.7239 9 17 9Z',
      key: 'o3awz0',
    },
  ],
  [
    'path',
    {
      d: 'M15 14.25C15.6904 14.25 16.25 13.6904 16.25 13C16.25 12.3096 15.6904 11.75 15 11.75C14.3096 11.75 13.75 12.3096 13.75 13C13.75 13.6904 14.3096 14.25 15 14.25Z',
      key: 'ejdty3',
    },
  ],
]);

export default Face5;
